import { AtkNav } from "./AtkNav";
import { AutotractorOverwatch } from "./AutotractorOverwatch";
import { buildPermission } from "portal/utils/auth";
import { FullViewportPage } from "portal/components/Page";
import { Header } from "portal/components/header/Header";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { UnauthorizedPage } from "portal/components/UnauthorizedPage";
import { useTranslation } from "react-i18next";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import React, { FunctionComponent } from "react";

const _Autotractor: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header title={t("models.autotractor.autonomy")}>
        <AtkNav />
      </Header>
      <FullViewportPage>
        <div className="pt-24 h-full">
          <AutotractorOverwatch />
        </div>
      </FullViewportPage>
    </>
  );
};

export const Autotractor = withAuthorizationRequired(
  {
    or: [
      buildPermission(
        PermissionAction.read,
        PermissionResource.autotractor_jobs,
        PermissionDomain.all
      ),
      buildPermission(
        PermissionAction.read,
        PermissionResource.autotractor_jobs,
        PermissionDomain.customer
      ),
    ],
  },
  _Autotractor,
  <UnauthorizedPage />
);
